module.exports = __webpack_public_path__ + "static/img/savePic.fc7b67b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/savePic.png
// module id = +O2w
// module chunks = 1